import assert from 'assert-ts';
import type {Schemas} from 'domainTypes/dto';
import type {Lock} from '../types';

export const mapLocksDto = (dto: Schemas.LocksDto): Lock[] => {
  return dto.locks?.map(mapLockDto) ?? [];
};

export const mapOptionalLockDto = (dto?: Schemas.LockDto): Lock | undefined =>
  dto ? mapLockDto(dto) : undefined;

export const mapLockDto = (dto: Schemas.LockDto): Lock => {
  return {
    id: assert(dto.id, 'mapLockDto: id expected'),
    contextId: assert(dto.contextId, 'mapLockDto: contextId expected'),
    contextType: assert(dto.contextType, 'mapLockDto: contextType expected'),
    lockedBy: assert(dto.lockedBy, 'mapLockDto: lockedBy expected'),
    lockedAt: assert(dto.lockedAt, 'mapLockDto: lockedAt expected'),
  };
};
